package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveTimer
import fr.manyverse.app.domain.repository.TimerRepository

/**
 * Use case for resuming a paused timer.
 * The countdown restarts from where it was paused for every targeted player.
 */
class ResumeTimerUseCase(
    private val timerRepository: TimerRepository
) {
    suspend operator fun invoke(
        timerId: String
    ): Result<ActiveTimer> {
        return timerRepository.resumeTimer(
            timerId = timerId
        )
    }
}
